import React from 'react';

const SettingsIcon = ({ color, width, height, ...props }) => {
  return (
    <span {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || '24'}
        height={height || '24'}
        viewBox="0 0 26 26"
        fill={color ? color : '#C4C4C4'}
      >
        <g
          id="Group_552"
          data-name="Group 552"
          transform="translate(-1342.5 -544)"
        >
          <path
            id="Path_837"
            data-name="Path 837"
            d="M75.969,571.977H74.338a2.4,2.4,0,0,1-2.394-2.393v-.552a10.573,10.573,0,0,1-1.63-.677l-.391.391a2.393,2.393,0,0,1-3.385,0l-1.153-1.153a2.394,2.394,0,0,1,0-3.386l.391-.391a10.435,10.435,0,0,1-.677-1.63h-.552a2.4,2.4,0,0,1-2.394-2.393v-1.632a2.4,2.4,0,0,1,2.394-2.393H65.1a10.468,10.468,0,0,1,.677-1.63l-.391-.391a2.394,2.394,0,0,1,0-3.386l1.153-1.153a2.393,2.393,0,0,1,3.385,0l.391.391a10.471,10.471,0,0,1,1.63-.676v-.552a2.4,2.4,0,0,1,2.394-2.394H75.97a2.4,2.4,0,0,1,2.394,2.394v.552a10.475,10.475,0,0,1,1.63.676l.391-.391a2.393,2.393,0,0,1,3.385,0l1.153,1.154a2.393,2.393,0,0,1,0,3.385l-.391.391a10.438,10.438,0,0,1,.677,1.63h.552a2.4,2.4,0,0,1,2.394,2.393v1.632a2.4,2.4,0,0,1-2.394,2.393h-.552a10.436,10.436,0,0,1-.677,1.63l.391.392a2.393,2.393,0,0,1,0,3.385l-1.153,1.153a2.392,2.392,0,0,1-3.385,0l-.391-.391a10.575,10.575,0,0,1-1.63.677v.552A2.4,2.4,0,0,1,75.969,571.977Zm-5.4-5.222a8.96,8.96,0,0,0,2.327.966.762.762,0,0,1,.571.738v1.125a.872.872,0,0,0,.87.87H75.97a.872.872,0,0,0,.87-.87v-1.125a.762.762,0,0,1,.571-.738,8.961,8.961,0,0,0,2.327-.966.762.762,0,0,1,.926.117l.8.8a.869.869,0,0,0,1.23,0l1.154-1.154a.87.87,0,0,0,0-1.23l-.8-.8a.761.761,0,0,1-.117-.926,8.989,8.989,0,0,0,.966-2.328.762.762,0,0,1,.738-.571H85.76a.871.871,0,0,0,.87-.87v-1.632a.871.871,0,0,0-.87-.87H84.636a.762.762,0,0,1-.738-.571,8.988,8.988,0,0,0-.966-2.328.761.761,0,0,1,.117-.926l.8-.8a.87.87,0,0,0,0-1.23l-1.154-1.154a.869.869,0,0,0-1.23,0l-.8.8a.762.762,0,0,1-.926.117,9,9,0,0,0-2.327-.966.762.762,0,0,1-.571-.738v-1.124a.872.872,0,0,0-.87-.871H74.338a.872.872,0,0,0-.87.871v1.124a.762.762,0,0,1-.571.738,8.994,8.994,0,0,0-2.327.966.762.762,0,0,1-.926-.117l-.8-.8a.869.869,0,0,0-1.23,0l-1.154,1.154a.87.87,0,0,0,0,1.23l.8.8a.761.761,0,0,1,.117.926,8.988,8.988,0,0,0-.966,2.328.762.762,0,0,1-.738.571H64.547a.871.871,0,0,0-.87.87v1.632a.871.871,0,0,0,.87.87h1.125a.762.762,0,0,1,.738.571,8.989,8.989,0,0,0,.966,2.328.761.761,0,0,1-.117.926l-.8.8a.87.87,0,0,0,0,1.23l1.154,1.154a.869.869,0,0,0,1.23,0l.8-.8A.765.765,0,0,1,70.569,566.755Z"
            transform="translate(1280.347 -1.977)"
            fill={color ? color : '#C4C4C4'}
          />
          <path
            id="Path_838"
            data-name="Path 838"
            d="M75.154,564.634a5.657,5.657,0,1,1,5.657-5.657A5.664,5.664,0,0,1,75.154,564.634Zm0-9.791a4.134,4.134,0,1,0,4.134,4.134A4.139,4.139,0,0,0,75.154,554.843Z"
            transform="translate(1280.347 -1.977)"
            fill={color ? color : '#C4C4C4'}
          />
        </g>
      </svg>
    </span>
  );
};

export default SettingsIcon;
